/** TanStack Query key for the full user-state map (GET /api/user-state). */
export const userStateQueryKey = ["userState"] as const;

/** TanStack Query key for the current session/identity (GET /auth/session). */
export const userQueryKey = ["user"] as const;
